// removed by extract-text-webpack-plugin
module.exports = {"actions":"add-vendor-rules-modal__actions___2uFV4","vendor-list":"add-vendor-rules-modal__vendor-list___1aGMA","vendor":"add-vendor-rules-modal__vendor___3GaaL"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/manage-vendors/add-vendor-rules-modal.scss
// module id = 1345
// module chunks = 0